import React, { useState } from 'react';
import { Layout, Button, Space, Dropdown } from 'antd';
import {
  BookOutlined,
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
  MenuOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import ThemeSettings from './ThemeSettings';

const { Header } = Layout;

const AppHeader = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const { isAuthenticated, logout, user } = useAuth();
  const { theme } = useTheme();
  const [themeSettingsVisible, setThemeSettingsVisible] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: user?.username
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout
    }
  ];

  return (
    <>
      <Header className="header">
        <Button
          type="text"
          icon={<MenuOutlined />}
          className="menu-trigger"
          onClick={onMenuClick}
          title="菜单"
        />
        <div className="logo">
          <BookOutlined /> {theme.headerTitle}
        </div>
        {isAuthenticated && (
          <div className="header-right">
            <Space size="middle">
              <Button
                type="text"
                icon={<SettingOutlined />}
                onClick={() => setThemeSettingsVisible(true)}
              >
                主题设置
              </Button>
              <Dropdown
                menu={{ items: userMenuItems }}
                placement="bottomRight"
              >
                <Button 
                  type="text" 
                  icon={<UserOutlined />}
                >
                  {user?.username || '用户'}
                </Button>
              </Dropdown>
            </Space>
          </div>
        )}
      </Header>
      <ThemeSettings
        open={themeSettingsVisible}
        onClose={() => setThemeSettingsVisible(false)}
      />
    </>
  );
};

export default AppHeader; 